import React, { Component } from 'react'
import img from '../../images/spa/cover_face.jpg'
import img2 from '../../images/spa/cover_back.jpg'
import img3 from '../../images/spa/cover_scrub.jpg'
import img4 from '../../images/spa/cover_footmassage.jpg'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { changePage,selectedItem } from '../../action/spa'

class SubMenu extends Component {
    goBack = () => {
        this.props.changePage("mainMenu");
    }
    goToItemInfo = (nextpage, title) => {
        this.props.changePage(nextpage);
        this.props.selectedItem(title);
    }
    render() {

        return (
            <div id="spa-menu-list" class="movie-widgets">
                <div class="search-back" data-target="spa-main" onClick={this.goBack}
                ><i class="fa fa-chevron-left"></i> Back</div>
                <h4>{this.props.subTitle}</h4>
                <ul class="movie-widgets-list">
                    <li onClick={() => { this.goToItemInfo("spaItemInfo", "Signature face massage") }}
                        data-target="spa-menu-list"
                        style={{ background: `url('${img}') center center no-repeat`, backgroundSize: "cover" }}>
                        <a ><span>Signature face massage | $20.00</span></a></li>
                    <li onClick={() => { this.goToItemInfo("spaItemInfo", "Signature back massage") }}
                        data-target="spa-menu-list"
                        style={{ background: `url('${img2}') center center no-repeat`, backgroundSize: "cover" }}>
                        <a ><span>Signature back massage | $20.00</span></a></li>
                    <li onClick={() => { this.goToItemInfo("spaItemInfo", "Signature body scrub") }}
                        data-target="spa-menu-list"
                        style={{
                            background: `url('${img3}') center center no-repeat`,
                            backgroundSize: "cover"
                        }}>
                        <a ><span>Signature body scrub | $20.00</span></a></li>
                    <li onClick={() => { this.goToItemInfo("spaItemInfo", "Signature foot massage") }}
                        data-target="spa-menu-list"
                        style={{ background: `url('${img4}') center center no-repeat`, backgroundSize: "cover" }}>
                        <a ><span>Signature foot massage | $20.00</span></a></li>
                </ul>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        subTitle: state.store.spa.subTitle
    }
}

export default connect(
    mapStateToProps,
    {
        changePage,
        selectedItem
    }
)(SubMenu);
